import { create } from "zustand";

interface JobApplicationFilterState {
  stateId: number | null;
  cityId: number | null;
  districtId: number | null;
  categoryId: number | null;
  subCategoryId: number | null;
  selectedStatus: number | null;
  startDate: string;
  endDate: string;
  ageFrom: number | null;
  ageTo: number | null;
  gender: string;
  applyFilter: boolean;
  searchValue: string;
  paginationModel: { page: number; pageSize: number };

  // setters
  setStateId: (val: number | null) => void;
  setCityId: (val: number | null) => void;
  setDistrictId: (val: number | null) => void;
  setCategoryId: (val: number | null) => void;
  setSubCategoryId: (val: number | null) => void;
  setSelectedStatus: (val: number | null) => void;
  setStartDate: (val: string) => void;
  setEndDate: (val: string) => void;
  setAgeFrom: (val: number | null) => void;
  setAgeTo: (val: number | null) => void;
  setGender: (val: string) => void;
  setApplyFilter: (val: boolean) => void;
  setSearchValue: (val: string) => void;
  setPaginationModel: (val: { page: number; pageSize: number }) => void;
  
  // reset all
  resetFilters: () => void;
}

export const useJobApplicationFilterStore = create<JobApplicationFilterState>((set) => ({
  stateId: null,
  cityId: null,
  districtId: null,
  categoryId: null,
  subCategoryId: null,
  selectedStatus: null,
  startDate: "",
  endDate: "",
  ageFrom: null,
  ageTo: null,
  gender: "",
  applyFilter: true,
  searchValue: "",
  paginationModel: { page: 1, pageSize: 10 },

  setStateId: (val) => set({ stateId: val }),
  setCityId: (val) => set({ cityId: val }),
  setDistrictId: (val) => set({ districtId: val }),
  setCategoryId: (val) => set({ categoryId: val }),
  setSubCategoryId: (val) => set({ subCategoryId: val }),
  setSelectedStatus: (val) => set({ selectedStatus: val }),
  setStartDate: (val) => set({ startDate: val }),
  setEndDate: (val) => set({ endDate: val }),
  setAgeFrom: (val) => set({ ageFrom: val }),
  setAgeTo: (val) => set({ ageTo: val }),
  setGender: (val) => set({ gender: val }),
  setApplyFilter: (val) => set({ applyFilter: val }),
  setSearchValue: (val) => set({ searchValue: val }),
  setPaginationModel: (val) => set({ paginationModel: val }),

  resetFilters: () =>
    set({
      stateId: null,
      cityId: null,
      districtId: null,
      categoryId: null,
      subCategoryId: null,
      selectedStatus: null,
      startDate: "",
      endDate: "",
      ageFrom: null,
      ageTo: null,
      gender: "",
      applyFilter: true,
      searchValue: "",
      paginationModel: { page: 1, pageSize: 10 },
    }),
}));
